import QuestionFieldMapSlideIn from './QuestionFieldMapSlideIn';

export default QuestionFieldMapSlideIn;
